function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var ElementVisible = /*#__PURE__*/function () {
  function ElementVisible(options) {
    var _this = this;

    _classCallCheck(this, ElementVisible);

    this.options = options;
    this.observer = null;
    this.visibleCount = 0;
    this.invisibleCount = 0;

    if (window.IntersectionObserver) {
      this.observer = new IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        if (entry) {
          if (entry.isIntersecting) {
            var _this$options$visible, _this$options;

            // 变可见
            (_this$options$visible = (_this$options = _this.options).visible) === null || _this$options$visible === void 0 ? void 0 : _this$options$visible.call(_this$options, ++_this.visibleCount);
          } else {
            var _this$options$invisib, _this$options2;

            // 变不可见
            (_this$options$invisib = (_this$options2 = _this.options).invisible) === null || _this$options$invisib === void 0 ? void 0 : _this$options$invisib.call(_this$options2, ++_this.invisibleCount);
          }
        }
      }, {});
    }
  }

  _createClass(ElementVisible, [{
    key: "bind",
    value: function bind() {
      if (this.observer) {
        this.observer.observe(this.options.el);
      } else {
        var _this$options$visible2, _this$options3;

        // 如果不存在，直接上报，防止埋点丢失
        (_this$options$visible2 = (_this$options3 = this.options).visible) === null || _this$options$visible2 === void 0 ? void 0 : _this$options$visible2.call(_this$options3, 1, {
          immediate: true
        });
      }
    }
  }, {
    key: "unbind",
    value: function unbind() {
      var _this$observer;

      (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.observe(this.options.el);
    }
  }]);

  return ElementVisible;
}();